import {get, post, put} from './http';
import appConfig from '@/config'

const apiBaseUrl = appConfig.apiBaseUrl
const apiUrl = path => `${apiBaseUrl}/${String(path).replace(/^\/+/, '')}`
// 首页图表布局

// 获取天气（Open-Meteo 免费天气 API）
export function getWeather (lat, lng) {
    const params = {
        latitude: lat,
        longitude: lng,
        current: 'temperature_2m,relative_humidity_2m,weather_code,wind_speed_10m,wind_direction_10m,wind_gusts_10m,pressure_msl,precipitation',
        hourly: 'wind_speed_10m,wind_gusts_10m,temperature_2m,relative_humidity_2m,precipitation_probability',
        past_days: 1,
        forecast_days: 1,
        timezone: 'auto',
        wind_speed_unit: 'ms'
    }
    return get('https://api.open-meteo.com/v1/forecast', params)
}


//获取前300条数据
export function getInit_home() {
    return get(apiUrl('init_home'))
}


//获取前300条数据
export function getInit_freq(param) {
    return get(apiUrl('init_freq'), param)
}

//获取热力图初始数据
export function getInit_heat(param) {
    return get(apiUrl('init_heat'),param)

}


export function getNode_status() {
    return get(apiUrl('status'))

}

// 获取最新的设备信息
export function get_devices() {
    return get(apiUrl('devices'))
}

// 获取特定节点最大值
export function get_max(param) {
    return get(apiUrl('s_max'),param)
}

// 获取最新的设备信息
export function get_all_v() {
    return get(apiUrl('all_v'))
}

// 地震信息
export function get_earthquake(stime, etime) {
    return get(`https://earthquake.usgs.gov/fdsnws/event/1/query?format=geojson&starttime=${stime}&endtime=${etime}&minlatitude=4&maxlatitude=54&minlongitude=72&maxlongitude=136`)
}

// 以监测建筑为中心查询周边地震；用于三维页的结构影响半径筛查。
export function get_nearby_earthquakes(stime, etime, lat, lng, radius = 1000) {
    return get('https://earthquake.usgs.gov/fdsnws/event/1/query', {
        format: 'geojson',
        starttime: stime,
        endtime: etime,
        latitude: lat,
        longitude: lng,
        maxradiuskm: radius,
        minmagnitude: 2.5,
        orderby: 'time',
        limit: 100
    })
}

// 获取最新的设备信息
export function get_exits_date(node) {
    return get(apiUrl('get_exits_date')+ `?node=${node}`)
}

// 获取丢包数量
export function get_loss(node) {
    return get(apiUrl('get_loss')+ `?node=${node}`)
}

// 获取电池和信号数量
export function get_bs(node, mode='single') {
    if(mode==='single') {
        return get(apiUrl('get_bs')+ `?node=${node}`)
    } else {
        return get(apiUrl('get_bs')+ `?nodes=${node}`)
    }

}

// 获取版本号
export function get_version(node) {
    return get(apiUrl('get_version')+ `?node=${node}`)
}

// 获取电压电流
export function get_voltage(node) {
    return get(apiUrl('get_voltage')+ `?node=${node}`)

}

// 获取同步信息
export function get_sync(node) {
    return get(apiUrl('get_sync')+ `?node=${node}`)
}

// 获取回归
export function get_fusion(node) {
    return get(apiUrl('get_fusion')+ `?node=${node}`)
}

// 登陆
export function user_login(authInfo) {
    return post(apiUrl('login'), authInfo)
}

// 生成嵌入链接免登录 token
export function createEmbedToken(data) {
    return post(apiUrl('api/auth/embed-token'), data)
}

// 获取页面的权限信息
export function get_pages_config() {
    return get(apiUrl('pages_config'))
}

// 更新当前 JWT 所属用户组的全局用户配置。
// 后端会覆盖整个 user_configs，因此调用方必须传入完整对象。
export function updateUserConfig(userConfigs) {
    return put(apiUrl('user_config'), { user_configs: userConfigs })
}


// 获取三维模型的权限信息
export function get_three_config() {
    return get(apiUrl('three_config'))
}

// 获取节点的配置信息
export function getDeviceConf(mac) {
    return get(apiUrl(`api/devcie_config/${mac}`))
}

// 发送指令
export function sendCommand(data) {
    return post(apiUrl('api/device_command'), data)
}

// 发送指令
export function sendEvent(data) {
    return post(apiUrl('api/detect_event'), data)
}


// 获取节点的数据
export function getData(params) {
    return get(apiUrl('api/pub/vdata'), params)
}

// 获取同步组列表
export function listSyncGroups(owner) {
    const query = owner ? `?owner=${encodeURIComponent(owner)}` : ''
    return get(apiUrl(`api/sync_groups${query}`))
}

// 获取节点的数据
export function get_geo_params() {
    return get(apiUrl('geo_params'))
}



// WEBPACK FOOTER //
// ./src/api/index.js